import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

// src/cn.ts
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export { cn };
//# sourceMappingURL=chunk-XUSDK76C.js.map
//# sourceMappingURL=chunk-XUSDK76C.js.map